// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"114":"component---src-templates-legal-info-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"114":"2998d7fdc74408ddfeab","678":"95bdefaa614c14dd63e3","731":"96ec69fb2b2d5b2cd365","843":"5ad8066e8e78f2e8deb4","883":"e459c72dea38f417ff1b"}[chunkId] + ".js";
};